/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IAddToComparisonRequest {
  /** Тип объекта для сравнения. **/
  propertyType: EPropertyType;
  /** Идентификатор объекта. **/
  propertyId: number;
}

export enum EPropertyType {
  /** Объявление **/
  'Offer' = 'offer',
  /** Новостройка **/
  'Newbuilding' = 'newbuilding',
}
